import { colours } from "styling/colours"
import { Column } from "../DataTable"
import { classes, style } from "typestyle"
import { clickableStyle } from "./tableStyle"
import { isEmpty } from "lodash"

type TableRowProps<T> = {
  rowValues: T
  rowIndex: number
  columns: Column<T>[]
  onRowClick?: (rowValues: T) => void
}

export const TableRow = <T extends Record<string, any>>(
  { rowValues, rowIndex, columns, onRowClick }: TableRowProps<T>) => {

  const rowClick = () => {
    onRowClick && onRowClick(rowValues)
  }

  const spreadProps = (width: string = 'auto', disabled: boolean = false) => style({
    background: disabled ? `${colours.disableTableRow} !important` : '',
    width: width,
    minWidth: width
  })

  return (
    <tr
      id={`table-row-${rowIndex}`}
      tabIndex={onRowClick ? 0 : -1}
      role={onRowClick ? "button" : undefined}
      onClick={(e) => {
        if ((e.target as HTMLElement).closest("button"))
          return;
        rowClick()
      }}
      onKeyDown={e => {
        if (e.key === "Enter") {
          if ((e.target as HTMLElement).closest("button"))
            return;
          rowClick()
        }
      }}
      className={classes(
        onRowClick && clickableStyle,
      )}
      aria-label={`table-row-${rowIndex}`}
    >
      {columns.filter(c => !c.hidden).map((column, index) => {
        let cellValue = rowValues[column.field];
        if (column.renderer)
          cellValue = column.renderer(cellValue || "", rowValues)
        if (column.defaultValue !== "" && isEmpty(cellValue)) {
          cellValue = column.defaultValue
        }

        return (
          <td key={`cell-${rowIndex}-${index}`}
            className={classes(spreadProps(column.width, column.disabled))}>
            {cellValue}
          </td>)
      })}
    </tr>
  )
}